// safeUrl.js — спільний гард для href зовнішніх посилань.
//
// Пропускаємо лише http(s)-адреси та відносні шляхи. Зовнішні URL (поле 951
// повного тексту, посилання зі «Змісту» 330^], зовнішні посилання журналу,
// DOI) вводить каталогізатор — без цієї перевірки в href міг би потрапити
// javascript:/data: і виконатись у сесії користувача при кліку. Внутрішні
// повні тексти йдуть окремою гілкою (тікет), їх URL будує бекенд із
// фіксованого шаблону — сюди не потрапляють.
export function safeExtUrl(u) {
  if (typeof u !== 'string') return undefined;
  return (/^https?:\/\//i.test(u) || u.startsWith('/')) ? u : undefined;
}
